import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import Cookies from "js-cookie";
import moment from "moment";
import $ from "jquery";
import { minDate } from "../../Constants/Constants";

const UpdateStaffDetailsModal = ({
  updateHandleChange,
  selectedRowsData,
  getData,
  setRowAddData,
}) => {
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");
  const [company, setCompany] = useState([]);
  const [companyId, setCompanyId] = useState("");

  const closeModal = () => {
    $(".custon-close-button-color").trigger("click");
  };

  function resetFileds(params) {
    setRowAddData({
      staff_name: "",
      staff_position: "",
      mob_num: "",
      employee_from_date: "",
      exit_from_date: "",
    });
  }

  const handleCompanyChange = (e) => {
    const value = e.target.value;
    setCompanyId(value ? value : "");
  };

  const updateProduct = async (e) => {
    e.preventDefault();
    const {
      id,
      staff_name,
      company_id,
      staff_position,
      mob_num,
      employee_from_date,
      exit_from_date,
    } = selectedRowsData;
    const from_date = moment
      .utc(employee_from_date, "YYYY-MM-DD")
      .toISOString();
    const exit_date = moment.utc(exit_from_date, "YYYY-MM-DD").toISOString();
    let BASE_URL = SERVER_URL + `/api/staff-detials/staffDetails/${user_id}`;

    const res = await fetch(BASE_URL, {
      method: "PUT",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id,
        company_id: companyId,
        staff_name,
        staff_position,
        mob_num,
        employee_from_date: from_date,
        exit_from_date: exit_date,
      }),
    });
    const response = await res.json();
    if (res.ok) {
      closeModal();
      setTimeout(() => {
        toast.success(response.message);
        // navigate("/dashboard");
      }, 1000);
      getData();
    } else {
      toast.error(response.message);
      getData();
    }
  };

  const getCompany = async () => {
    const BASE_URL = SERVER_URL + `/api/company/all-company-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    setCompany(result.data);
  };

  useEffect(() => {
    getCompany();
  }, []);

  useEffect(() => {
    if (selectedRowsData) {
      setCompanyId(selectedRowsData.company_id);
    }
  }, [selectedRowsData]);
  return (
    <>
      <div
        className="modal custom-modal fade"
        id="updateStaffModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        data-backdrop="static"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="imageZoomModalTitle">
                Update Staff Details
              </h5>
              <button
                type="button"
                className="custon-close-button-color close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={resetFileds}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="col-12 grid-margin">
                <div className="card">
                  <div className="card-body">
                    {/* <h4 className="card-title">Update Staff Details</h4> */}
                    <form className="form-sample" onSubmit={updateProduct}>
                      {/* <p className="card-description">Personal info</p> */}
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="company_id">Company Name</label>
                            <select
                              className="form-control form-control-lg"
                              onChange={handleCompanyChange}
                              value={companyId}
                              required
                              id="company_id"
                            >
                              <option value="">Select Company Name</option>
                              {company &&
                                company?.length > 0 &&
                                company?.map((item, index) => {
                                  return (
                                    <option
                                      key={index}
                                      value={item.id}
                                    >{`${item.company_name}, ${item.location}`}</option>
                                  );
                                })}
                            </select>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="Product">Employee Name</label>
                            <input
                              type="text"
                              className="form-control"
                              name="staff_name"
                              id="Product"
                              value={selectedRowsData?.staff_name}
                              onChange={updateHandleChange}
                              required
                              autoComplete="off"
                              placeholder="Employee Name"
                            />  
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="Quantity">Employee Position</label>
                            <input
                              type="text"
                              className="form-control"
                              name="staff_position"
                              id="Quantity"
                              placeholder="Employee Position"
                              value={selectedRowsData?.staff_position}
                              onChange={updateHandleChange}
                              required
                              autoComplete="off"
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="Size">Mob. Number</label>
                            <input
                              type="number"
                              className="form-control"
                              name="mob_num"
                              id="Size"
                              value={selectedRowsData?.mob_num}
                              onChange={updateHandleChange}
                              required
                              autoComplete="off"
                              min="10"
                              placeholder="Mob. Number"
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="date">Employee From Date</label>
                            <input
                              type="date"
                              className="form-control"
                              name="employee_from_date"
                              id="date"
                              value={selectedRowsData.employee_from_date}
                              onChange={updateHandleChange}
                              required
                              autoComplete="off"
                              // min={minDate}
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="date">Exit From Date</label>
                            <input
                              type="date"
                              className="form-control"
                              name="exit_from_date"
                              id="date"
                              value={selectedRowsData.exit_from_date}
                              onChange={updateHandleChange}
                              // required
                              autoComplete="off"
                              // min={minDate}
                            />
                          </div>
                        </div>
                      </div>
                      <button
                        className="btn btn-primary mr-2 mt-3"
                        type="submit"
                        // onClick={updateProduct}
                      >
                        Save
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UpdateStaffDetailsModal;
